export interface SupplierUser {
  supplier_user_id: number
  name: string
  email: string
  role: 'admin' | 'user'
  is_active: boolean
  created_by?: number
  created_by_name?: string
  created_at: string
  updated_at: string
  permissions?: Record<string, PermissionLevel>
  // Mart v2: the branch this user works for; null = every branch (always null for an admin).
  supplier_branch_id?: number | null
  supplier_branch_name?: string | null
}

export type PermissionLevel = 'NONE' | 'EDIT'

export interface UserPermission {
  module: string
  permission_level: PermissionLevel
}

export interface CreateUserRequest {
  name: string
  email: string
  password: string
  role: 'admin' | 'user'
  supplier_branch_id?: number | null
}

export interface UpdateUserRequest {
  name: string
  email: string
  password?: string
  role: 'admin' | 'user'
  supplier_branch_id?: number | null
}

export interface UpdatePermissionsRequest {
  permissions: Record<string, PermissionLevel>
}

export interface UsersQueryResponse {
  data: SupplierUser[]
  total: number
}

export interface UserResponse {
  user: SupplierUser
}

export interface PermissionsResponse {
  permissions: Record<string, PermissionLevel>
}

export interface ApiResponse<T = any> {
  status_code: string
  message: string
  data?: T
  details?: any
}

// Module definitions for permissions
export const MODULES = {
  PRODUCTS: 'products',
  ORDERS: 'orders',
  SALES_REPORTS: 'sales_reports',
  PAYMENT_REPORTS: 'payment_reports',
  STOCK_REPORTS: 'stock_reports',
  DISCOUNTS: 'discounts',
  DASHBOARD: 'dashboard',
  DAILY_DEALS: 'daily_deals',
  REQUESTS: 'requests',
  LOSS_OF_OPPORTUNITY: 'loss_of_opportunity',
  PROFILE: 'profile',
  USER_MANAGEMENT: 'user_management',
  DUMYAH_ADS: 'dumyah_ads',
} as const

export type ModuleKey = typeof MODULES[keyof typeof MODULES]

export const MODULE_LABELS: Record<ModuleKey, string> = {
  [MODULES.PRODUCTS]: 'Products',
  [MODULES.ORDERS]: 'Orders',
  [MODULES.SALES_REPORTS]: 'Sales Reports',
  [MODULES.PAYMENT_REPORTS]: 'Payment Reports',
  [MODULES.STOCK_REPORTS]: 'Stock Reports',
  [MODULES.DISCOUNTS]: 'Discounts',
  [MODULES.DASHBOARD]: 'Dashboard',
  [MODULES.DAILY_DEALS]: 'Daily Deals',
  [MODULES.REQUESTS]: 'Requests',
  [MODULES.LOSS_OF_OPPORTUNITY]: 'Loss of Opportunity',
  [MODULES.PROFILE]: 'Profile',
  [MODULES.USER_MANAGEMENT]: 'User Management',
  // TODO(tenant-brand): this MODULE_LABELS map is a module-scope const evaluated at
  // import time — before bootstrapTenantBranding()/setTenantConfig() runs — so calling
  // tenantBrandName() here would capture the fail-open default, not the active tenant.
  // Leave literal until this is refactored to a getter/lookup resolved at render time.
  [MODULES.DUMYAH_ADS]: 'Dumyah Ads',
}

export const PERMISSION_LABELS: Record<PermissionLevel, string> = {
  NONE: 'No Access',
  EDIT: 'Full Access',
}
